<template>
  <div class="modal-card" style="width: auto">
    <header class="modal-card-head">
      <p class="modal-card-title">Registrándome</p>
    </header>
    <div class="modal-card-body">
      <form autocomplete="on">
        <b-field label="Correo">
          <b-input name="email" type="email" placeholder="Correo" v-model="email"></b-input>
        </b-field>
        <b-field label="Nombre Completo">
          <b-input
            placeholder="nombres y apellidos"
            v-model="name"
            name="nombre"
            required
            validation-message="Indique un nombre completo"
          ></b-input>
        </b-field>
        <b-field label="DNI/Pasaport/Carné de extranjería">
          <b-input
            name="dni"
            v-model="di"
            placeholder="xxxxxxxx"
            min="8"
            max="11"
            required
            validation-message="Indique un DNI verdadero"
            pattern="[0-9]*"
          ></b-input>
        </b-field>
        <b-field label="Numero Telefónico">
          <b-input
            name="phone"
            v-model="phone"
            placeholder="xxxxxxxx"
            required
            validation-message="Indique un teléfono válido"
          ></b-input>
        </b-field>
        <b-field label="Digite una clave">
          <b-input
            name="password"
            type="password"
            placeholder="Digite una clave"
            password-reveal
            v-model="password"
          ></b-input>
        </b-field>
        <b-field label="Repita la clave">
          <b-input
            name="password_c"
            type="password"
            placeholder="Repita la clave"
            password-reveal
            v-model="c_password"
          ></b-input>
        </b-field>
        <p class="title is-7 has-text-success">
          <b-icon icon="security" size="is-small"></b-icon>
          Las claves se cifran por su seguridad.
        </p>
        <b-button @click="register" :loading="lregistrando" type="is-primary">Registrarme</b-button>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  data: () => {
    return {
      email: "",
      password: "",
      c_password: "",
      di: "",
      phone: "",
      name: "",
      lregistrando: false
    };
  },
  methods: {
    register() {
      this.lregistrando = true;
      const form = new FormData();
      form.append("email", this.email);
      form.append("password", this.password);
      form.append("phone", this.phone);
      form.append("name", this.name);
      form.append("di", this.di);
      form.append("c_password", this.c_password);
      this.$http
        .post(this.$store.state.url + "/api/register", form, {
          useCredentails: true
        })
        .then(response => {
          // this.$store
          //   .dispatch("setUser", response.data.success)
          //   .then(() => this.$router.push("/usuario"));
          // console.log(this.$store.state.token);
          this.$store.dispatch("setUser", response.data.data).then(() => {
            (this.lregistrando = false),
              this.$emit("correctRegister", { user: this.$store.state.user });
          });
          console.log(this.$store.state.user);
          console.log(response);
        })
        .catch(() => {
          this.lregistrando = false;
          this.$buefy.dialog.alert({
              title: "Hubo un error ",
              message:
                "Las datos son incorrectas o alguien ya los tiene registrados.",
              type: "is-warning",
              hasIcon: true,
              icon: "alert-octagon"
            });
        });
    }
  }
};
</script>
